import { type DefaultProps } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import cx from 'classnames'
import { type FC, useId } from 'react'
import { useNavigate } from 'react-router'
import { twMerge } from 'tailwind-merge'

const translationPrefix = 'default.account_options.'

interface CheckingOverflowMenuProps extends DefaultProps {
  alias: number
}

export const CheckingOverflowMenu: FC<CheckingOverflowMenuProps> = ({ className, id, testId, ariaLabel, alias }) => {
  const { t } = useTranslation('features-account')

  const navigate = useNavigate()
  // Component base class names. Can be overriden by className property.
  const baseClass = cx('overflow-menu flex flex-col items-start')

  // Final class names
  const finalClasses = twMerge(baseClass, className)

  const CHECKING_OVERFLOW_OPTIONS = [
    {
      title: t(`${translationPrefix}debit_card`),
      onClick: () => {
        void navigate(WEALTH_ROUTES.CHECKING_ACCOUNT_DEBIT_CARD.path.replace(':alias', alias.toString()))
      },
      key: useId(),
    },
    {
      title: t(`${translationPrefix}activity`),
      onClick: () => {
        void navigate(WEALTH_ROUTES.CHECKING_ACCOUNT_ACTIVITY.path.replace(':alias', alias.toString()))
      },
      key: useId(),
    },
    {
      title: t(`${translationPrefix}statements`),
      onClick: () => {
        void navigate(WEALTH_ROUTES.DOCUMENTS_STATEMENTS.path)
      },
      key: useId(),
    },
    {
      title: t(`${translationPrefix}tax_documents`),
      onClick: () => {
        void navigate(WEALTH_ROUTES.DOCUMENTS.path)
      },
      key: useId(),
    },
    {
      title: t(`${translationPrefix}account_details`),
      onClick: () => {
        void navigate(WEALTH_ROUTES.CHECKING_ACCOUNT_DETAILS.path.replace(':alias', alias.toString()))
      },
      key: useId(),
    },
    {
      title: t(`${translationPrefix}account_beneficiaries`),
      onClick: () => {
        void navigate(WEALTH_ROUTES.SETTINGS_BENEFICIARIES.path)
      },
      key: useId(),
    },
  ]

  return (
    <div
      className={finalClasses}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      {CHECKING_OVERFLOW_OPTIONS.map((option, index) => (
        <button
          data-testid={`checking-overflow-menu-option-${index}`}
          key={option.key}
          className="w-full text-body flex py-4 px-2 text-base border-b border-light last-of-type:border-none"
          type="button"
          onClick={option.onClick}
        >
          {option.title}
        </button>
      ))}
    </div>
  )
}
